export const DEFAULT_OPTION = {
  value: 'default',
  text: 'Choose',
  disabled: true,
};
